import React, { useCallback } from "react";
import { useGraphTime } from "../GraphTimeProvider";
import { TimeSelector } from "./TimeSelector";
export const TIMESELECTOR_HEIGHT = 100;
export const TimeSelectorContainer = () => {
    const { graphTime, updateTime, max, min, pause, forward, backward, speed, changeSpeed, isPaused, canUseLive, goLive, } = useGraphTime();
    const handleChangeTime = useCallback((newTime) => {
        updateTime(newTime);
        pause();
    }, []);
    return (React.createElement(TimeSelector, { onReverse: backward, onChange: handleChangeTime, onChangeSpeed: changeSpeed, speed: speed, value: graphTime, min: min, max: max, height: TIMESELECTOR_HEIGHT, onPause: pause, onPlay: forward, isPaused: isPaused, canUseLive: canUseLive, onLive: goLive }));
};
//# sourceMappingURL=TimeSelectorContainer.js.map